import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { WebinarBanner } from '../components/WebinarBanner';
import { AboutSection } from '../components/AboutSection';
import { CurriculumOverview } from '../components/CurriculumOverview';
import { CourseGrid } from '../components/CourseGrid';
import { SpeakersSection } from '../components/SpeakersSection';
import { VenueGallery } from '../components/VenueGallery';
import { PartnerLogos } from '../components/PartnerLogos';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { CurriculumPopup } from '../components/CurriculumPopup';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780]" data-id="element-931">
      <Navbar data-id="element-932" />
      <main data-id="element-933">
        <HeroSection data-id="element-934" />
        <WebinarBanner data-id="element-935" />
        <AboutSection data-id="element-936" />
        <CurriculumOverview data-id="element-937" />
        <CourseGrid data-id="element-938" />
        <SpeakersSection data-id="element-939" />
        <VenueGallery data-id="element-940" />
        <PartnerLogos data-id="element-941" />
        <TestimonialsSection data-id="element-942" />
        <CTASection data-id="element-943" />
      </main>
      <Footer data-id="element-944" />
      <CookieBanner data-id="element-945" />
      <CurriculumPopup data-id="element-946" />
    </div>;
}